import { createStore } from 'vuex'
import $api from '@/utils/axios';
import { ElLoading } from 'element-plus'

/**
 * Vuex�������A�޲z
 * @param options {Array} �Ω��Vtabs���Ʋ�
 */
const store = createStore({
    state: {
        options: [],
        activeIndex: '/',
        userInfo: {},
        menuIndex: '0',
        pageAuth: [],
        balAmt: 0
    },
    mutations: {
        // �K�[tabs
        add_tabs(state, data) {
            this.state.options.push(data);
        },
        // �s�xindex
        save_index(state, data) {
            this.state.menuIndex = data ? data : '0';
        },
        // �R��tabs
        delete_tabs(state, route) {
            let index = 0;
            for (let option of state.options) {
                if (option.route === route) {
                    break;
                }
                index++;
            }
            this.state.options.splice(index, 1);
        },
        // �]�m���e�E����tab
        set_active_index(state, index) {
            this.state.activeIndex = index;
        },
        // �]�m�Ա��H��
        save_detail_info(state, info) {
            this.state.userInfo = info;
        },
        // �M���Ҧ���ñ
        clear_all_tabs() {
            this.state.options = [];
        },
        //�qname���oindex
        get_index_from_name(name) {
            return this.state.options.findIndex(x => x.name == name);
        },
        //���o���ϥΪ̩Ҧ��������v���]�w
        get_page_auth(state) {
            $api.GET('/api/Home/GetAuth', {
                FUNC_TYPE: "WEB" 
            }).then(function (response) {
                //�@���N����s�J
                store.state.pageAuth = response;
            }).catch(function (error) { });
        },
        //Loading Open
        loading_open(state) {
            let options = { text: 'Loading...' };
            state.loading = ElLoading.service(options);
        },
        //Loading Close
        loading_close(state) {
            state.loading.close();
        },
        setBalAmt(state, val) {
            state.balAmt = val;
            localStorage.setItem("BalAmt", val);
        }
    },
    actions: {
        loading_open(context) {
            context.commit('loading_open');
        },
        loading_close(context) {
            context.commit('loading_close');
        },
        async getBalAmt({ commit }) {
            const response = await $api.GET("/api/OutletUser/GetBalAmt", {
                VENDOR_ID: localStorage.getItem("VendorId"),
                USER_CODE: localStorage.getItem("UserCode")
            });

            commit("setBalAmt", response);
        }
    },
    getters: {
        check_auth: (state) => (funcName) => {//�T�{�\���v��
            var obj = state.pageAuth.filter(x => x.URL_ADDR == state.activeIndex);
            if (obj.length > 0) {
                return obj[0]['CAN_' + funcName] == 'Y';
            } else {
                return false;
            }
        }
    }
});

export default store;